import { captureUnderscoreErrorException } from '@sentry/nextjs';
import Router from 'next/router';

import Error404Page from 'components/404';
import Error500Page from 'components/500';

import { hasUpperCase } from 'lib/string';

const Error = ({ statusCode }) =>
  statusCode.toString().startsWith('5') ? <Error500Page /> : <Error404Page />;

Error.getInitialProps = async (ctx) => {
  const { asPath, req, res, err } = ctx;
  const statusCode = res?.statusCode || err?.statusCode || 404;
  const url = asPath || req?.url;

  if (url && hasUpperCase(url)) {
    const isServer = !!res;

    if (!isServer) {
      Router.push(url.toLowerCase());
      return;
    }

    res.writeHead(308, { Location: url.toLowerCase() });
    res.end();
    return;
  }

  await captureUnderscoreErrorException(ctx);

  return { statusCode };
};

export default Error;
